/**
 * Created by lenovo on 2017/11/22.
 */
import {apiPath} from '../common/js/config.js';
import myAjax from '../common/js/request';
import Vue from 'vue';
import Vuex from 'vuex';
import {commonFn} from '../common/js/common.js';
import dayjs from 'dayjs';
import {getClassStorage, setClassStorage} from '../common/js/utils';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userInfo: {},
		xcxVocUrlObj: {}, //小程序连线短链对象
		/* 签到弹窗 */
		hideSignTips: false,
		platform: '16',
		/*节日弹框是否显示*/
		isFrame: 0,
		// 底部tab激活标示
		curFooterPage: 1,
		/*用户类型*/
		userType: null,
		// 用户手机号
		userPhone: '',
		// 提示框弹框
		layer: {
			isShow: false,
			text: '',
			time: 1500
		},
		// loading弹框
		loading: {
			isShow: false,
			text: '加载中...'
		},
		channel: '',
		// 微信分享链接
		wxConfig: {},
		// 未读条数
		noReadNums: 0,
		// 需要设置页面的滚动高度
		indexScrollTop: 0,
		userListScrollTop: 0,
		scIndexScrollTop: 0,
		classIndexScrollTop: 0,
		meScrollTop: 0,
		/* 快速提问问题 */
		quickAskObj: {
			askList: [],
			userInfo: [],
			currentCateIndex: 0,
			currentAskIndex: 0,
			currentUserInfoIndex: 0,
			askContent: ''
		},
		// 免费听弹窗
		freeListen: {
			introPop: false,
			howdoPop: false,
			hasFreeListen: 0,
			showSharePop: false,
			codePop: false
		},
		/* 标示用户是否已经登录 */
		isLogin: false,
		/* 用户登录标示 */
		token: '',
		// 猜你喜欢弹窗
		mayLikePop: false,
		// 猜你喜欢悬浮按钮
		mayLikeFixedIcon: false,
		// 全局登录弹窗
		loginPop: true,
		// 是否显示优惠券弹窗
		couponPop: false,
		couponData: null,
		wxPublicPayUrl: '',
		seckillNew: false, //是否是秒杀活动新手
		isFromDetail: false, // 是否塔罗投放从问题详情返回问题列表页面
		isFromChat: false, // 是否投放从投放咨询室页面返回投放问题列表页面
		configTemp: {}, // 配置中心数据
		userLevel: null
	},
	getters: {
		isHideService(state, getters) {
			let userInfo = state.userInfo;
			if (userInfo.id) {
				return (userInfo.channel || '').match(/^dx/) && userInfo.level === 1;
			}
			return true;
		},
		isHideSpareAndLine(state, getters) {
			let userInfo = state.userInfo;
			if (userInfo.id) {
				return (userInfo.channel || '').match(/^dx3/) && userInfo.level === 1;
			}
			return true;
		}
	},
	mutations: {
		setHideSignTips(state, bool) {
			state.hideSignTips = bool;
		},
		// 改变底部tab激活状态
		changeCurrent(state, current) {
			state.curFooterPage = current;
		},
		setClassScrollTop(state, top) {
			state.classIndexScrollTop = top;
		},
		//设置用户id
		setUserId(state, userId) {
			state.userId = userId;
		},
		//设置用户类型
		setUserType(state, userType) {
			state.userType = userType;
		},
		//设置用户信息
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		//设置用户手机号
		setUserPhone(state, userPhone) {
			state.userPhone = userPhone;
		},
		setUserLevel(state, level) {
			state.userLevel = level;
		},
		// 显示出提示框
		showLayer(state, text) {
			state.layer.isShow = true;
			state.layer.text = text;
		},
		// 显示loading弹窗
		showLoading(state, text) {
			state.loading.isShow = true;
			state.loading.text = text || '加载中...';
		},
		// 隐藏loading弹框
		hideLoading(state) {
			state.loading.isShow = false;
		},
		// 设置连线短链
		setXcxVocUrlObj(state, obj) {
			state.xcxVocUrlObj[obj.id] = obj.url;
			console.log(`设置连线短链`, obj);
		},
		//获取当前链接
		getLocationHref(state, location) {
			state.location = location;
		},
		// 设置渠道来源
		setChannel(state, channel) {
			state.channel = channel;
		},
		// 设置微信配置信息
		setWxConfig(state, config) {
			state.wxConfig = config;
		},
		// 设置未读条数
		setNoReadNums(state, numbers) {
			state.noReadNums = numbers;
		},
		// 设置页面的高度
		setIndexScrollTop(state, top) {
			state.indexScrollTop = top;
		},
		setUserListScrollTop(state, top) {
			state.userListScrollTop = top;
		},
		setMeScrollTop(state, top) {
			state.meScrollTop = top;
		},
		setScScrollTop(state, top) {
			state.scIndexScrollTop = top;
		},
		/*设置节日弹框*/
		setFrame(state, isFrame) {
			state.isFrame = isFrame;
		},
		// 快速提问部分start
		setQuickList(state, list) {
			state.quickAskObj.askList = list;
		},
		setCurrentCateIndex(state, index) {
			state.quickAskObj.currentCateIndex = index;
		},
		setCurrentAskIndex(state, index) {
			state.quickAskObj.currentAskIndex = index;
		},
		setAskContent(state, content) {
			state.quickAskObj.askContent = content;
		},
		setUserInfoList(state, list) {
			state.quickAskObj.userInfo = list;
		},
		setCurrentUserInfoIndex(state, index) {
			state.quickAskObj.currentUserInfoIndex = index;
		},
		setCurrentUserInfoMessId(state, obj) {
			state.quickAskObj.userInfo[obj.index].id = obj.val;
		},
		// 快速提问部分end

		// 设置用户登录状态
		setUserIsLogin(state, status) {
			state.isLogin = status;
		},
		// 设置平台
		setPlatform(state, val) {
			state.platform = val;
		},
		// 设置用户token
		setUserToken(state, token) {
			state.token = token;
		},
		// 设置猜你喜欢弹窗是否显示
		setMayLikePop(state, status) {
			state.mayLikePop = status;
		},
		setMayLikeFixedIcon(state, status) {
			state.mayLikeFixedIcon = status;
		},
		// 设置登录弹窗是否显示
		setLoginPop(state, status) {
			state.loginPop = status;
		},
		setCouponPop(state, status) {
			state.couponPop = status;
		},
		setCouponData(state, data) {
			state.couponData = data;
		},
		setFreeListen(state, content) {
			state.freeListen[content.name] = content.val;
		},
		setWxPublicPayUrl(state, url) {
			state.wxPublicPayUrl = url;
		},
		// 设置是否是秒杀活动的新手
		setSeckillNew(state, created_time) {
			if (created_time > '1577635200') {
				state.seckillNew = true;
			}
		},
		setIsFromDetail(state, val) {
			state.isFromDetail = val;
		},
		setIsFromChat(state, val) {
			state.isFromChat = val;
		},
		setConfigTemp(state, val) {
			state.configTemp = val;
		}
	},
	actions: {
		async getIsNewUserAndHasCoupon({commit}) {
			try {
				let getIsNewUser = myAjax.get(apiPath.isPopBoot, {step: 2}),
					getHasCoupon = myAjax.get(apiPath.isUseCoupon);

				let {new_user, coupon} = await getIsNewUser,
					{is_use} = await getHasCoupon;

				// 新人，新手券还没使用，首页弹猜你喜欢弹窗
				if (new_user && !is_use) {
					commit('setCouponData', coupon);
					// 投放页面，不显示新手券弹窗
					const hidePath = ['/taluoAsks', '/taluoAskDetail', '/tfChatRoom', '/tfChat'];
					if (!hidePath.includes(location.pathname)) {
						// 如果当天已经展示过，就不再展示（需求：红莲）
						const hasBeenShown = getClassStorage('coupon', 'couponPop').val;
						if (hasBeenShown) return;

						commit('setCouponPop', true);

						const expire = dayjs().endOf('date').unix();
						setClassStorage('coupon', 'couponPop', '1', expire);
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		// 获取免费听弹窗
		getFreeListenFormPort({commit}) {
			myAjax
				.get(apiPath.freeListenPop, {})
				.then((res) => {
					commit('setFreeListen', {
						name: 'introPop',
						val: res.is_pop
					});
				})
				.catch((e) => {});
		},
		// 获取用户是否可以免费听
		getHasFreeListen({commit}) {
			myAjax
				.get(apiPath.hasFreeListen, {})
				.then((res) => {
					commit('setFreeListen', {
						name: 'hasFreeListen',
						val: res.is_free
					});
				})
				.catch((e) => {});
		},
		// 获取配置中心数据
		async getConfig({commit}) {
			const channel =
				commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
			let {fields = null} = await myAjax.get(
				'https://relayfe.caij100.com/api/acttemp/pj/yqw_temp',
				{
					channel,
					env: commonFn.isSandbox() ? 1 : 0 // 1为测试服，其他为正式服
				}
			);
			let res = await myAjax.get(
				'https://relayfe.caij100.com/api/channel/group',
				{
					group_name: '_footer',
					reg: channel.match(/^([^_]+(?:_[^_]+)?)/)[0]
				},
				{needchannel: false}
			);
			fields.company =
				res.list.length > 0
					? res.list[0].group_name.split('_')[1]
					: '广东很久文化传播有限公司';
			fields && commit('setConfigTemp', fields);
		}
	}
});



// WEBPACK FOOTER //
// ./src/vuex/index.js